export default "__VITE_ASSET__B_Z5SPqK__"